/**
 * Labstep
 *
 * @module grid/Index/coldefs/entityUser
 * @desc Column Definition for an entityUser
 */

import type { ValueGetterParams } from 'ag-grid-community';
import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { EntityUserActionManageList } from 'labstep-web/components/EntityUser/Action/Manage/List';
import { ICONS } from 'labstep-web/constants/icons';
import type {
  CellEditorParams,
  CellRendererParams,
} from 'labstep-web/core/DataGrid/types';
import {
  getEditable,
  stopEditingAndFocus,
} from 'labstep-web/core/DataGrid/utils';
import type {
  EntityUser,
  EntityUserEntities,
} from 'labstep-web/models/entity-user.model';

/**
 * Column definition for Collaborators
 * @returns Column definition
 */
const colDefEntityUser = {
  colId: 'entity_users',
  headerName: 'Collaborators',
  headerComponentParams: {
    icon: ICONS.user.secondary,
  },
  cellRenderer: (params: CellRendererParams<EntityUserEntities>) => {
    if (!params.data) {
      return '';
    }
    return <EntityUserActionManageList entity={params.data} />;
  },
  cellEditor: (params: CellEditorParams<EntityUserEntities>) => {
    const { data } = params;
    return (
      <EntityUserActionManage
        entity={data}
        viewComponent={null}
        open
        onClose={(): void => stopEditingAndFocus(params)}
      />
    );
  },
  cellEditorPopup: true,
  editable: getEditable(),
  cellStyle: { display: 'flex', alignItems: 'center' },
  valueGetter: (params: ValueGetterParams): number =>
    params.data.entity_users_count,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data && params.node?.data?.entity_users_preview
      ? params.node?.data?.entity_users_preview
          .map(
            (entityUser: EntityUser) => entityUser.user?.name || '',
          )
          .join(', ')
      : '',
};

export default colDefEntityUser;
